import { computed, toValue, type MaybeRefOrGetter } from 'vue'
import { useConfigStore, type Country } from '@/js/stores/configStore'

/**
 * Resolve a country record from an alpha2 code.
 * Returns an empty object when the code is unknown or the country list has not loaded yet,
 * so callers can read optional fields (stateLabel, zipLabel, requireRegion) without guarding.
 */
export function useCountry(countryId: MaybeRefOrGetter<string | undefined>) {
  const configStore = useConfigStore()

  return computed<Partial<Country>>(() => configStore.countryByCode.get(toValue(countryId) || '') || {})
}
